<template>
    <footer class="footer">
        <div class="footer-top py-60">
            <v-container>
                <v-row class="align-center flex-column-reverse flex-lg-row">
                    <v-col cols="12" lg="9">
                        <p class="font-size-12 font-size-lg-14">
                            <strong>UWSS</strong> <br>
                            <strong>CEO</strong> Lee Dae Ho<br class="sp">
                            <span class="d-none d-lg-inline-block" style="width: 16px"></span>
                            <strong>Company Registration Number</strong> 113-86-64890<br class="sp">
                            <span class="d-none d-lg-inline-block" style="width: 16px"></span>
                            <strong>Mail Order Number</strong> 2019-서울성북-1021 호 <br>
                            <strong>Head Office</strong> 234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea <br>
                            <strong>Phone</strong> 070-4640-3030<br class="sp">
                            <span class="d-none d-lg-inline-block" style="width: 16px"></span>
                            <strong>Email</strong> sales@f1security.co.kr<br class="sp">
                            <span class="d-none d-lg-inline-block" style="width: 16px"></span>
                            <strong>Fax</strong> 02-6944-8448
                        </p>
                    </v-col>
                    <v-col cols="12" lg="3" class="d-flex justify-lg-end">
                        <img src="/images/logo-dark.svg" alt="" class="d-block" width="182">
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <div class="footer-bottom py-32">
            <v-container>
                <div class="d-flex justify-space-between">
                    <p class="font-size-12 font-size-lg-14">
                        © 2022. F1Security Corp. all rights reserved.
                    </p>
                </div>
            </v-container>
        </div>
    </footer>
</template>

<script>
import UScrollTop from "@/components/dumb/u-scroll-top.vue";
export default {
    components: {
        UScrollTop,
    },
    data(){
        return {
            // site : null,
            // sites : [
            //     {
            //         name:"네이버",
            //         link:"https://www.naver.com/"
            //     },
            //     {
            //         name:"다음",
            //         link:"https://www.daum.net/"
            //     },
            // ]
        };
    },
    mounted(){
    },
    methods: {
        // changeD : function() {
        //     window.open(this.site, '_blank');
        // }
    }
}
</script>

<style scoped>
.footer{
    color: #80838f;
    background-color: #1f232f;
}

.footer-top{
    border-bottom: 1px solid #363b49;
}

.footer-top p{
    line-height: 24px;
}

.footer-top p strong{
    font-weight: 700;
    color: #b0b3c1;
}

.footer-bottom a{
    transition: 0.2s ease-out;
}

@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
    .footer-top p{
        line-height: 30px;
    }

    .footer-bottom a:hover{
        color: #b0b3c1;
    }
}
@media (min-width:1200px){
}
</style>
